<lib-dialog
  [title]="
    (isConfirmEmail
      ? 'email-phone-confirmation-pin-dialog.text.email-confirmation'
      : 'email-phone-confirmation-pin-dialog.text.phone-confirmation'
    ) | translate
  "
  [isLoading]="isLoading"
  [displayActionContainerAsColumnOnMobile]="true"
  (closeButtonClick)="closeDialog()"
>
  <div body>
    {{
      (isConfirmEmail
        ? 'email-phone-confirmation-pin-dialog.text.enter-to-confirm-email'
        : 'email-phone-confirmation-pin-dialog.text.enter-to-confirm-phone'
      ) | translate
    }}.

    <lib-spacer></lib-spacer>

    <lib-pin-code-input [formControl]="controlPin"></lib-pin-code-input>

    <lib-spacer></lib-spacer>

    <lib-info-box>
      <span
        >{{
          (isConfirmEmail
            ? 'email-phone-confirmation-pin-dialog.text.pin-sent-to-email'
            : 'email-phone-confirmation-pin-dialog.text.pin-sent-to-phone'
          ) | translate
        }}
        {{ username }}</span
      >
    </lib-info-box>
  </div>

  <ng-container action>
    <button
      mat-stroked-button
      color="primary"
      [disabled]="!isAbleToResendPin()"
      (click)="resendPin()"
    >
      {{ 'email-phone-confirmation-pin-dialog.buttons.resend' | translate }}
      <ng-container *ngIf="resendPinCountdownInSecond > 0"
        >({{
          'email-phone-confirmation-pin-dialog.text.in-second'
            | translate : { seconds: resendPinCountdownInSecond }
        }})</ng-container
      >
    </button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!isAbleToSubmit()"
      (click)="submit()"
    >
      {{ 'email-phone-confirmation-pin-dialog.buttons.submit' | translate }}
    </button>
  </ng-container>
</lib-dialog>
